/**
 * @internal
 */
export class AttrJsonUser {
  CanDevelop: boolean;

  // new v13
  CanAdmin: boolean;

  /**
   * user can switch editions
   */
  canSwitchEdition: boolean;
}
